export default {
  title: "It's Dangerous To Go Alone! Take This. 🗡️"
}
